import { styled } from 'styled-components';

export const SearchJobHitHolder = styled.div`
  display: flex;
  flex-direction: column;
  container-type: inline-size;
`;
